import { Routes } from '@angular/router';

export const currencyRoutes: Routes = [
  // Currency Profile
  {
    path: 'currency-profile',
    data: { moduleCode: 'currency_profile' },
    children: [
      { path: '', loadComponent: () => import('./currency-profile/currency-profile').then((m) => m.CurrencyProfile) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./currency-profile/currency-profile-details/currency-profile-details').then((m) => m.CurrencyProfileDetails)
      }
    ]
  },
  // Exchange Rates
  {
    path: 'exchange-rates',
    data: { moduleCode: 'currency_exchange_rate' },
    children: [
      { path: '', loadComponent: () => import('./exchange-rates/exchange-rates').then((m) => m.ExchangeRates) },
      {
        path: 'add',
        loadComponent: () => import('./exchange-rates/exchange-rates-details/exchange-rates-details').then((m) => m.ExchangeRatesDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./exchange-rates/exchange-rates-details/exchange-rates-details').then((m) => m.ExchangeRatesDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./exchange-rates/exchange-rates-import/exchange-rates-import').then((m) => m.ExchangeRatesImport)
      }
    ]
  },
  // // Rate Types
  // {
  //   path: 'rate-types',
  //   data: { moduleCode: 'currency_rate_type' },
  //   children: [
  //     { path: '', component: RateTypes },
  //     { path: 'details/:id', component: RateTypesDetails },
  //   ]
  // },
  // // Default Rate
  // {
  //   path: 'default-rate',
  //   data: { moduleCode: 'currency_default_rate' },
  //   children: [
  //     { path: '', component: DefaultRate }
  //   ]
  // },
  // // Revaluation
  // {
  //   path: 'revaluation',
  //   data: { moduleCode: 'currency_revaluation' },
  //   children: [
  //     { path: '', component: Revaluation },
  //     { path: 'add', component: AssetTypeDetails },
  //     { path: 'details/:id', component: AssetTypeDetails },
  //     { path: 'import', component: AssetTypeImport },
  //   ]
  // },
  // // Integration
  // {
  //   path: 'integration',
  //   data: { moduleCode: 'currency_integration' },
  //   children: [
  //     { path: '', component: Integration },
  //     { path: 'add', component: AssetTypeDetails },
  //     { path: 'details/:id', component: AssetTypeDetails },
  //     { path: 'import', component: AssetTypeImport },
  //   ]
  // },
  // Exchange Rate Update
  {
    path: 'new-exchange-rate',
    data: { moduleCode: 'currency_exchange_rate_new' },
    children: [
      { path: '', loadComponent: () => import('./new-exchange-rate-req/new-exchange-rate-req').then((m) => m.NewExchangeRateReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./new-exchange-rate-req/new-exchange-rate-req-details/new-exchange-rate-req-details').then(
            (m) => m.NewExchangeRateReqDetails
          )
      }
    ]
  },
  // Exchange Rate Update
  {
    path: 'exchange-rate-update',
    data: { moduleCode: 'currency_exchange_rate_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-exchange-rate-req/update-exchange-rate-req').then((m) => m.UpdateExchangeRateReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-exchange-rate-req/update-exchange-rate-req-details/update-exchange-rate-req-details').then(
            (m) => m.UpdateExchangeRateReqDetails
          )
      }
    ]
  }
];
